import { formatClipDuration } from './clipDuration';

type Translate = (key: string, values?: Record<string, unknown>) => string;
const CODE = 'cpm_clip_too_short';
const record = (value: unknown): Record<string, unknown> => value && typeof value === 'object' ? value as Record<string, unknown> : {};
const seconds = (value: unknown) => (typeof value === 'number' && Number.isInteger(value) && value >= 0 ? value : null);

/** The too-short clip message, naming both lengths when the server sent them. */
export function clipDurationSubmissionFeedback(error: unknown, t: Translate): string | null {
  const root = record(error);
  const entries = [...(Array.isArray(root.graphQLErrors) ? root.graphQLErrors : []), ...(Array.isArray(root.errors) ? root.errors : []), root].map(record);
  const match = entries.find(entry => {
    const nested = record(record(entry.extensions).error);
    return entry.message === CODE || nested.message === CODE || record(entry.extensions).code === CODE;
  });
  if (!match) return null;
  const extensions = record(match.extensions);
  const details = { ...record(record(extensions.error).details), ...extensions };
  const duration = seconds(details.durationSeconds);
  const min = seconds(details.minDurationSeconds);
  if (duration === null || !min) return t(`campaign.submit.errors.${CODE}`);
  return t('campaign.submit.clipTooShort', { duration: formatClipDuration(duration), min: formatClipDuration(min) });
}
